function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5720_9254)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.3503 21.0166C38.745 20.608 38.9634 20.0607 38.9585 19.4926C38.9535 18.9245 38.7256 18.381 38.3239 17.9793C37.9222 17.5776 37.3788 17.3497 36.8107 17.3448C36.2426 17.3399 35.6953 17.5583 35.2867 17.9529L23.8033 29.4363L16.6533 22.2863C16.2447 21.8916 15.6974 21.6732 15.1293 21.6781C14.5612 21.6831 14.0178 21.9109 13.616 22.3127C13.2143 22.7144 12.9865 23.2578 12.9815 23.8259C12.9766 24.394 13.195 24.9413 13.5897 25.3499L22.2563 34.0166C22.6626 34.4228 23.2136 34.651 23.7882 34.651C24.3627 34.651 24.9137 34.4228 25.32 34.0166L38.32 21.0166H38.3503Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52 26C52 40.3433 40.3433 52 26 52C11.6567 52 0 40.3433 0 26C0 11.6567 11.6567 0 26 0C40.3433 0 52 11.6567 52 26ZM47.6667 26C47.6667 37.96 37.96 47.6667 26 47.6667C14.04 47.6667 4.33333 37.96 4.33333 26C4.33333 14.04 14.04 4.33333 26 4.33333C37.96 4.33333 47.6667 14.04 47.6667 26Z",
  fill: "currentColor"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5720_9254"
}, /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  fill: "white"
})));
function SvgTestPassed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestPassed);
export default __webpack_public_path__ + "static/media/TestPassed.228f1e6d.svg";
export { ForwardRef as ReactComponent };